import { HeadCell } from '../../../types/table';
import { ClaimRowData } from './entitlements-ui-types';

export const claimRowHeadCells: HeadCell<ClaimRowData>[] = [
  {
    id: 'brand',
    label: 'Brand code',
    key: 'brand',
  },
  {
    id: 'code',
    label: 'Code',
    key: 'code',
  },
  {
    id: 'isActive',
    label: 'Active',
    key: 'isActive',
  },
  {
    id: 'validFrom',
    label: 'Valid From',
    key: 'validFrom',
  },
  {
    id: 'validTo',
    label: 'Valid To',
    key: 'validTo',
  },
];

export default claimRowHeadCells;
